import { render } from "./tentang.vue?vue&type=template&id=9d30db94"
import script from "./tentang.vue?vue&type=script&lang=js"
export * from "./tentang.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__